import React, { useContext } from 'react';
import { Checkbox } from 'semantic-ui-react';
import moment from 'moment-timezone';
import DataContext from '../../contexts/DataContext';

// Meetings are an hour long and the API blocks both 30-minute slots
const MEETING_DURATION_MINUTES = 60;

const formatMeetingSlot = (meetingAt, timeZone) => {
  const start = moment.tz(meetingAt, timeZone);
  const end = start.clone().add(MEETING_DURATION_MINUTES, 'minutes');
  const sameMeridiem = start.format('A') === end.format('A');
  return `${start.format('ddd, MMM D')} · ${start.format(sameMeridiem ? 'h:mm' : 'h:mm A')}–${end.format('h:mm A z')}`;
};

const BlockTimeOption = ({
  meetingAt, checked, onChange, helpText, disabled,
}) => {
  const { user } = useContext(DataContext);

  return (
    <div className="block-time-option">
      <div className="section-label">Your availability</div>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={(e, data) => onChange(data.checked)}
        label={{
          children: (
            <>
              <strong>{`Block ${formatMeetingSlot(meetingAt, user.timeZone)} on my availability`}</strong>
              <span className="help-text">{helpText}</span>
            </>
          ),
        }}
      />
    </div>
  );
};

export default BlockTimeOption;
